import { render, staticRenderFns } from "./dataTableColumn.vue?vue&type=template&id=3b2aab10"
import script from "./dataTableColumn.vue?vue&type=script&lang=js"
export * from "./dataTableColumn.vue?vue&type=script&lang=js"
import style0 from "./dataTableColumn.vue?vue&type=style&index=0&id=3b2aab10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports